module.exports = __webpack_public_path__ + "static/img/2023_9_8_4.a861870a.a861870.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_4.a861870a.jpg
// module id = yeIv
// module chunks = 0